import React from 'react';
import MarkdownPage from '../components/MarkdownPage';

// Prod file for every environment: regulations.md is not uploaded to the dev bucket yet
const TERMS_URL = 'https://zwyk0bucket0prod0nuvog6.blob.core.windows.net/zwyk-public-prod/regulations.md';

const Terms: React.FC = () => (
  <MarkdownPage url={TERMS_URL} loadingText="Ładowanie regulaminu…" />
);

export default Terms;
